module.exports = __webpack_public_path__ + "img/tiaoxinma.435998a9.png";